export default {
  name: 'Row',
  components: {
    'vue-region': require('./Region/index.vue').default,
    'vue-city': require('./City/index.vue').default,
    'vue-radius': require('../../Radius/index.vue').default,
  },
  props: ['index'],
};
